export default __webpack_public_path__ + "static/media/references_m.c31e2ce6.jpg";